<div class="digital-caseflow-details">
  <div>
    <span class="dcfDetailText grey">{{ 'digital-caseflow-flow' | translate }}</span>
    <span class="dcfDetailText"> {{ flowLog.flowName }}</span>
  </div>
  <div>
    <span class="dcfDetailText grey">{{ 'digital-caseflow-activity-log-status' | translate }}</span>
    <span class="dcfDetailText red" *ngIf="flowLog.flowResult == 'FAILED'"> {{ 'status-failed-capital' | translate }}</span>
    <span class="dcfDetailText teal" *ngIf="flowLog.flowResult != 'FAILED'"> {{ 'status-succeeded-capital' | translate }}</span>
    <button class="primary-button resume-button" (click)="resumeFlow()" [disabled]="!canResume()" [ngbPopover]="canResume() ? ('digital-caseflow-resume-hover' | translate) : ('digital-caseflow-resume-disabled-hover' | translate)" triggers="hover" placement="left-bottom" popoverClass="wide-popover">
      <div>
        {{ 'digital-caseflow-resume' | translate }}
      </div>
    </button>
    <span class="execute-container" *ngIf="resuming">
      <span class="dcfDetailText">{{ 'digital-caseflow-executing' | translate }}</span>
      <div class="spinner-border spinner-border-sm" role="status"></div>
    </span>
    <span class="execute-container" *ngIf="flowExecuted">
      {{ executionError ? executionError : ('digital-caseflow-executed' | translate) }}
    </span>
  </div>

  <table class="primary-table">
    <caption>{{ 'digital-caseflow-table-header-validations' | translate }}</caption>
    <thead>
      <tr>
        <th class="unsortable-column small-th">{{ 'digital-caseflow-table-header-name' | translate }}</th>
        <th class="unsortable-column">{{ 'digital-caseflow-table-header-message' | translate }}</th>
        <th class="unsortable-column tiny-th">{{ 'digital-caseflow-table-header-status' | translate }}</th>
      </tr>
    </thead>
    <tbody>

    <tr *ngFor="let activity of validationTableEntries">
      <td><span class="dcfDetailText">{{ activity.name }}</span></td>
      <td><span class="dcfDetailText">{{ activity.message }}</span></td>
      <td><span class="dcfDetailText">{{ activity.status }}</span></td>
    </tr>
    </tbody>
  </table>

  <table class="primary-table">
    <caption>{{ 'digital-caseflow-table-header-actions' | translate }}</caption>
    <thead>
    <tr>
      <th class="unsortable-column small-th">{{ 'digital-caseflow-table-header-name' | translate }}</th>
      <th class="unsortable-column">{{ 'digital-caseflow-table-header-message' | translate }}</th>
      <th class="unsortable-column tiny-th">{{ 'digital-caseflow-table-header-status' | translate }}</th>
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let activity of activityTableEntries">
      <td><span class="dcfDetailText">{{ activity.name }}</span></td>
      <td><span class="dcfDetailText">{{ activity.message }}</span></td>
      <td><span class="dcfDetailText">{{ activity.status }}</span></td>
    </tr>
    </tbody>
  </table>
</div>
